import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import showdown from 'showdown'
import { Spinner, Popup, popupActions, Tooltip } from 'dbrain-web-ui-lib'
import config from '../../config'
import history from '../../history'
import TypeSwitcher from './typeswitcher'
import Result from '../Result'
import * as tasksActions from './actions'
import IconFullDescription from './types/images/help.filled.inline.svg'

import './style'

const bodyClass = 'label-page'
const fullDescriptionPopupId = 'fullDescriptionPopupId'
const captionButtonDivider = ['@#', '#@']

const resultDelayPolygons = 99999
const resultDelayLabels = 99999

const assignmentsPerTask = 8
const assignmentsPerTaskTextCategorization = 4

const allTasksQuantityLive = Object.keys(config.routes.live.order).length * assignmentsPerTask
const allTasksQuantityDemo = type => (
	type === 'textcategorization'
		? assignmentsPerTaskTextCategorization
		: assignmentsPerTask
)

const currentTaskType = (type) => {
	const t = []

	Object.keys(config.routes.live.order)
		.forEach((val, num) => {
			if (val === type) t.push(num + 1)
		})

	return t[0]
}

const tasksDone = (currentType) => {
	let doneCount
	const { order } = config.routes.live

	Object.keys(order).forEach((type, num) => {
		if (type === currentType) {
			doneCount = num
		}
	})

	return doneCount * assignmentsPerTask
}

const getFirst = () => {
	const { order } = config.routes.live
	const { toolType, preset } = order[Object.keys(order)[0]]

	return { toolType, preset }
}

class Task extends Component {
	constructor(props) {
		super(props)
		this.state = {
			task: props.tasks.assignments[0],
			isFullDescriptionPopupVisible: false,
			isTooltipShown: false,
			isMarkButtonInCaption: false,
			isFirstDescriptionShow: false,
			isNeedToShowResults: false,
			isNeedToShowTaskResults: false,
			comparedResult: null,
		}

		this.loadingID = null
		this.doneTimeout = null
		this.liveResults = []
		this.rightScoreThreshold = {
			aabb: 0.8,
			segmentation: 0.8,
			ocr: 1,
			label: 1,
			textcategorization: 1,
		}
		this.markdownConverter = new showdown.Converter()
	}

	componentDidMount() {
		const {
			actions,
			preset,
			toolType,
			isLive,
		} = this.props

		if (isLive) {
			const first = getFirst()
			actions.getTasks(first.preset, first.toolType)
		} else {
			actions.getTasks(preset, toolType)
		}

		if (this.popupvideo) {
			this.popupvideo.onload = () => {
				this.buildPopupVideo()
			}
		}

		document.body.classList.add(bodyClass)
	}

	componentWillReceiveProps(nextProps) {
		const { tasks } = this.props
		const { tasks: tasksNext } = nextProps
		const nextTask = tasksNext.assignments[0]
		const prevTask = tasks.assignments[0]

		if (
			(nextTask && prevTask) &&
			(nextTask.id !== prevTask.id)
		) {
			clearInterval(this.doneTimeout)
		}

		if (
			(nextTask && !prevTask) ||
			(nextTask && prevTask && nextTask.id !== prevTask.id)
		) {
			this.setTask(nextTask)
		}

		if (!nextTask && prevTask) {
			this.setState({ task: null, isNeedToShowResults: true })
		}

		if (!tasksNext.isTasksLoading && tasks.isTasksLoading && !tasksNext.assignments.length) {
			history.push(config.routes.index)
		}

		if (
			(prevTask && nextTask) &&
			(nextTask.id === prevTask.id) &&
			tasksNext.comparedResult !== null
		) {
			const { comparedResult } = tasksNext

			clearInterval(this.doneTimeout)

			this.setState({ comparedResult }, () => {
				this.updateLiveResults()
				this.handlePolygonsResult()
			})
		} else {
			clearInterval(this.doneTimeout)
		}
	}

	componentWillUnmount() {
		document.body.classList.remove(bodyClass)
		this.props.actions.resetTasks()
		if (this.expirationTimeoutId) {
			clearTimeout(this.expirationTimeoutId)
			this.expirationTimeoutId = null
		}
	}

	setTask(task) {
		clearTimeout(this.loadingID)

		if (task.payload.image) {
			const taskImage = new Image()

			taskImage.onload = () => {
				let isMarkButtonInCaption = false
				const isNeedToShowTaskResults = false
				const re = `${captionButtonDivider[0]}(.*)${captionButtonDivider[1]}`
				const { payload } = task

				if (
					new RegExp(re, 'gi').test(task.caption) &&
					payload.values.length === 1
				) {
					const capButton = task.caption.match(re)
					const capArray = task.caption.split(capButton[0])
					const caption = (
						<Fragment>
							{`${capArray[0].trim()} `}
							<span className="btn btn-gray rainbow pressed">
								{capButton[1]}
							</span>
							{` ${capArray[1].trim()}`}
						</Fragment>
					)

					task.caption = caption
					isMarkButtonInCaption = true
				}


				this.setState({
					task,
					isMarkButtonInCaption,
					isNeedToShowTaskResults,
				}, () => {
					if (this.checkFullDescriptionVisibility()) this.fullDescriptionPopupVisibility(true)
				})
			}

			taskImage.src = task.payload.image
		}

		if (task.payload.text) {
			const isNeedToShowTaskResults = false

			this.setState({
				task,
				isNeedToShowTaskResults,
			})
		}
	}

	buildPopupVideo() {
		const v = this.popupvideo.play()

		if (v !== undefined) {
			v.catch(() => {
				this.popupvideo.style.display = 'none'
				this.popupvideofallback.setAttribute(
					'src',
					this.popupvideofallback.getAttribute('data-src'),
				)
			})
		}
	}

	updateLiveResults() {
		const { task, comparedResult } = this.state
		const { rightScoreThreshold } = this
		const result = comparedResult.score >= rightScoreThreshold[task.type] ? 1 : 0

		this.liveResults.push(result)
	}

	checkFullDescriptionVisibility() {
		const { task, isFirstDescriptionShow } = this.state
		const { projectId } = task
		const ss = window.sessionStorage

		if (ss.projectId !== projectId) {
			this.setState({ isFirstDescriptionShow: true })
			ss.projectId = projectId
			return true
		}

		if (isFirstDescriptionShow) {
			this.setState({ isFirstDescriptionShow: false })
		}

		return false
	}

	fullDescriptionPopupVisibility(isFullDescriptionPopupVisible) {
		if (this.popupvideo) this.buildPopupVideo()
		this.setState({ isFullDescriptionPopupVisible })
	}

	doneTask(payload, userData) {
		const { type } = this.state.task
		const delay = type === 'label' || type === 'ocr'
			? resultDelayLabels
			: resultDelayPolygons

		this.doneTimeout = setTimeout(() => {
			this.nextTask(payload, userData)
		}, delay * 1000)
	}

	markTask(payload, _, type) {
		const { task } = this.state
		const { actions } = this.props
		const comparedResult = null

		this.setState({ comparedResult })

		if (type === 'label' || type === 'ocr') {
			actions.compareLabels(payload, task.payload.result, type)
		} else
		if (type === 'textcategorization') {
			actions.compareRanges(payload, task.payload.result, type)
		} else {
			actions.comparePolygons(payload, task.payload.result, type)
		}
	}

	handlePolygonsResult() {
		this.setState({
			isNeedToShowTaskResults: true,
		}, () => {
			this.doneTask(null, null)
		})
	}

	nextTask(payload, userData) {
		clearInterval(this.doneTimeout)
		this.props.actions.markTask(this.state.task, payload, userData, false)
	}

	tooltipVisibility(isTooltipShown) {
		this.setState({ isTooltipShown })
	}

	render() {
		const {
			fullDescriptionPopupVisibility,
			rightScoreThreshold,
			liveResults,
		} = this
		const {
			task,
			isMarkButtonInCaption,
			isFirstDescriptionShow,
			isNeedToShowResults,
			isNeedToShowTaskResults,
			comparedResult,
		} = this.state
		const {
			tasks,
			actions,
			app,
			popup,
			isLive,
			toolType: taskToolType,
		} = this.props
		const { isMobile } = app
		const { onboarding, preset, toolType } = tasks

		if (!task && !isNeedToShowResults) {
			return <Spinner className="task-spinner" />
		}

		// if (!task && isNeedToShowResults) {
		if (isNeedToShowResults) {
			return (
				<Result
					app={app}
					toolType={taskToolType}
					liveResults={liveResults}
				/>
			)
		}

		const fullDescriptionLink = (
			<Tooltip
				text="Help"
				position="bottom"
				show={this.state.isTooltipShown}
			>
				<span
					className="link fulldescrtiption-link"
					tabIndex="0"
					role="button"
					onClick={() => { this.fullDescriptionPopupVisibility(true) }}
					onMouseEnter={() => { this.tooltipVisibility(true) }}
					onMouseLeave={() => { this.tooltipVisibility(false) }}
				>
					<IconFullDescription className="description-icon-full" />
				</span>
			</Tooltip>
		)

		const description = task.description ? (
			<div className="description font-regular text-4-type-2">
				{`${task.description} `}
				{fullDescriptionLink}
			</div>
		) : ''

		const assignmentsDone = isLive
			? tasksDone(task.type)
			: 0

		const perTask = this.props.tasks.preset === 'textcategorization'
			? assignmentsPerTaskTextCategorization
			: assignmentsPerTask

		const currentTaskNum = assignmentsDone + (perTask - tasks.assignments.length) + 1
		const tasksQuantity = isLive ? allTasksQuantityLive : allTasksQuantityDemo(this.props.tasks.preset)

		const currentTaskCaption = (
			<div className="text-5-type-1 caption-currentTask">
				{currentTaskNum}/{tasksQuantity}
			</div>
		)

		const caption = task.caption ? (
			<div className={`caption ${isMobile ? 'text-3-type-1' : 'text-2-type-2'}`}>
				{this.state.task.caption}
			</div>
		) : ''

		/* eslint-disable max-len */
		const testLabel = tasks.onboarding_status ? (
			<div className="text-6-type-5 font-bold test">
				<span className="upper">Test task</span> (<span data-testid="taskProgressCount">{tasks.onboarding_status.assignments_completed + 1}</span>/{tasks.onboarding_status.assignments_total})
			</div>
		) : ''

		const popupVideo = tasks.onboarding.video && tasks.onboarding.gif
			? (
				<div className="descriptionpopup-video">
					<video loop autoPlay ref={(c) => { this.popupvideo = c }}>
						<source src={tasks.onboarding.video} type="video/mp4" />
					</video>

					<img
						alt=""
						src=""
						ref={(c) => { this.popupvideofallback = c }}
						data-src={tasks.onboarding.gif}
					/>
				</div>
			)
			: ''

		const popupTaskCounter = isLive
			? (
				<div className="descriptionpopup-taskcounter text-5-type-1">
					Task type {currentTaskType(task.type)} of {Object.keys(config.routes.live.order).length}
				</div>
			)
			: ''

		const fullDescriptionPopup = (
			<Popup
				id={fullDescriptionPopupId}
				handleClose={false}
				className="popup-task-fulldescription"
				popup={{
					isActive: this.state.isFullDescriptionPopupVisible,
					id: fullDescriptionPopupId,
				}}
				actions={actions}
			>
				<div className="gap-5" />
				<div className="row">
					<div className="col-1 sm-hidden" />
					<div className="col-4 col-sm-4 col-xs-2">
						{popupTaskCounter}
						<div className="descriptionpopup-header text-1-type-2">
							{onboarding.caption}
						</div>
						<div
							className="description descriptionpopup-main font-regular text-3-type-3"
							dangerouslySetInnerHTML={{
								__html: this.markdownConverter.makeHtml(onboarding.description),
							}}
						/>
						{popupVideo}
						<div
							className="col-3 description descriptionpopup-extra font-regular text-4-type-2"
							dangerouslySetInnerHTML={{
								__html: this.markdownConverter.makeHtml(onboarding.video_description),
							}}
						/>
						<div className="buttons buttons-pull-right">
							<span
								role="button"
								tabIndex="0"
								className="btn"
								onClick={() => { this.fullDescriptionPopupVisibility(false) }}
							>
								Got it
							</span>
						</div>
					</div>
				</div>
			</Popup>
		)

		const prop = {
			isMobile,
			testLabel,
			toolType,
			preset,
			task,
			caption,
			description,
			fullDescriptionLink,
			fullDescriptionPopup,
			fullDescriptionPopupVisibility,
			tasks,
			popup,
			actions,
			isMarkButtonInCaption,
			currentTaskCaption,
			isFirstDescriptionShow,
			isNeedToShowTaskResults,
			rightScoreThreshold,
			comparedResult,
			isMock: this.props.tasks.isMock,
			nextTask: this.nextTask.bind(this),
			normalizePoints: this.props.actions.normalizePoints,
			markTask: this.markTask.bind(this),
		}

		return <TypeSwitcher {...prop} />
	}
}

Task.defaultProps = {
	isLive: false,
	toolType: null,
	preset: null,
	comparedResult: {},
}

Task.propTypes = {
	app: PropTypes.object.isRequired,
	tasks: PropTypes.object.isRequired,
	popup: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
	isLive: PropTypes.bool,
	toolType: PropTypes.string,
	preset: PropTypes.string,
	comparedResult: PropTypes.object,
}

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(Object.assign({}, popupActions, tasksActions), dispatch),
})

export default connect(state => state, mapDispatchToProps)(Task)
